"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
exports.DrawerContext = React.createContext({
    openDrawer: null,
    updateOpenDrawer: (openDrawer) => { }
});
class DrawerContextProvider extends React.Component {
    constructor(props) {
        super(props);
        this.updateOpenDrawer = (openDrawer) => {
            this.setState({
                openDrawer
            });
        };
        this.state = { openDrawer: null, updateOpenDrawer: this.updateOpenDrawer };
    }
    render() {
        const { children } = this.props;
        return (React.createElement(exports.DrawerContext.Provider, { value: this.state }, children));
    }
}
exports.DrawerContextProvider = DrawerContextProvider;
exports.DrawerContextConsumer = exports.DrawerContext.Consumer;
